/* Natural Roots — add-to-cart for add-on offers and "bought together".
   Kept separate from nr-bundle.js so the bundle logic stays untouched.

   [data-nr-add-variant="ID"]            → adds one variant
   [data-nr-add-variants="ID1,ID2,..."]  → adds several in ONE request, so the
                                           discount is evaluated once against the
                                           full cart and the drawer opens once
   [data-nr-dedupe]                      → skips variants already in the cart,
                                           so clicking "add both" after the
                                           bundle is already there does not add
                                           a second bundle */
(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function openDrawer(attempt) {
    attempt = attempt || 0;
    var theme = window.MinimogTheme || {};
    var strings = window.MinimogStrings || {};
    var drawer = document.querySelector('m-cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      if (theme.Notification) {
        var target = drawer.querySelector('m-cart-items');
        if (target) {
          theme.Notification.show({
            target: target,
            method: 'prepend',
            type: 'success',
            message: strings.itemAdded || 'تمت الإضافة إلى السلة',
            delay: 400
          });
        }
      }
      drawer.open();
      return;
    }

    if (attempt < 10) {
      setTimeout(function () {
        openDrawer(attempt + 1);
      }, 150);
      return;
    }

    if (theme.Notification) {
      theme.Notification.show({
        target: document.body,
        method: 'appendChild',
        type: 'success',
        message: strings.itemAdded || 'تمت الإضافة إلى السلة',
        last: 3000,
        sticky: true
      });
    }
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.classList[loading ? 'add' : 'remove']('nr-is-loading');
    if (loading) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('disabled');
    }
  }

  function collectItems(button) {
    var quantity = parseInt(button.getAttribute('data-quantity') || '1', 10) || 1;
    var many = button.getAttribute('data-nr-add-variants');

    if (many) {
      var seen = {};
      return many
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(function (id) {
          // Guard against the same variant being listed twice
          if (!id || seen[id]) return false;
          seen[id] = true;
          return true;
        })
        .map(function (id) {
          return { id: id, quantity: quantity };
        });
    }

    var one = button.getAttribute('data-nr-add-variant');
    return one ? [{ id: one, quantity: quantity }] : [];
  }

  function idsInCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var map = {};
        (cart.items || []).forEach(function (item) {
          map[String(item.variant_id)] = true;
        });
        return map;
      })
      .catch(function () {
        // If the cart cannot be read, fall through and add everything
        return {};
      });
  }

  function postItems(items) {
    var settings = window.MinimogSettings || {};
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );

    var config;
    if (typeof fetchConfig === 'function') {
      config = fetchConfig('javascript');
    } else {
      config = { headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
    }
    config.method = 'POST';
    config.body = JSON.stringify({
      items: items,
      sections: sections,
      sections_url: window.location.pathname
    });

    var addUrl = (settings.routes && settings.routes.cart_add_url) || root() + 'cart/add.js';
    return fetch(addUrl, config).then(function (response) {
      return response.json();
    });
  }

  function finish(response) {
    var theme = window.MinimogTheme || {};

    if (response && response.status) {
      if (theme.Notification) {
        theme.Notification.show({
          target: document.body,
          method: 'appendChild',
          type: 'warning',
          message: response.description || 'تعذّرت الإضافة إلى السلة.',
          last: 4000,
          sticky: true
        });
      }
      return;
    }

    if (window.MinimogEvents && theme.pubSubEvents) {
      window.MinimogEvents.emit(theme.pubSubEvents.cartUpdate, { cart: response });
    }
    document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));
    openDrawer();
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('[data-nr-add-variant], [data-nr-add-variants]');
    if (!button) return;

    event.preventDefault();
    if (button.hasAttribute('disabled')) return;

    var items = collectItems(button);
    if (!items.length) return;

    setLoading(button, true);

    var prepare = button.hasAttribute('data-nr-dedupe')
      ? idsInCart().then(function (present) {
          return items.filter(function (item) {
            return !present[String(item.id)];
          });
        })
      : Promise.resolve(items);

    prepare
      .then(function (toAdd) {
        if (!toAdd.length) {
          // Everything is already in the cart — just show it
          openDrawer();
          return null;
        }
        return postItems(toAdd);
      })
      .then(function (response) {
        if (response) finish(response);
      })
      .catch(function (error) {
        console.error('nr-addon: add to cart failed', error);
      })
      .finally(function () {
        setLoading(button, false);
      });
  });
})();